/* hdt-nav-collapse.js — menu-bottom header sticky collapse toggle.
   When the header is scrolled past (kalles StickyHeader adds .scrolled-past-header),
   the bottom menu row is folded away (CSS) and .hdt-nav-collapse-toggle appears
   next to the logo. Clicking it toggles .nav-collapse-open on the header wrapper.
   ~0.6 KB, deferred, no dependencies. */
(function () {
  var header = document.querySelector('.hdt-section-header.hdt-header-menu-bottom');
  if (!header) return;
  var btn = header.querySelector('.hdt-nav-collapse-toggle');
  if (!btn) return;

  function close() {
    header.classList.remove('nav-collapse-open');
    btn.setAttribute('aria-expanded', 'false');
  }

  btn.addEventListener('click', function () {
    var open = header.classList.toggle('nav-collapse-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* reset when back at the top (header no longer collapsed) */
  window.addEventListener('scroll', function () {
    if (!header.classList.contains('scrolled-past-header')) close();
  }, { passive: true });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();
